export const ITEM_TYPES = {

    UNKNOWN: "unknown",
    CARD: "card",
    COMIC: "comic",
    COIN: "coin",
    FUNCO: "funko",
    FIGURE: "figure",
    MEMORABILIA: "memorabilia",
    BUILDING_BLOCKS: "building_blocks",
    MUSIC: "music",
    VINTAGE: "vintage",
    OTHER: "other",
};